import { TextColors } from '@picsart/design-system/foundation/colors';
import { TypographyT5, TypographyT6 } from '@picsart/design-system/foundation/typography';

import { useCallback, useState } from 'react';

import classnames from 'classnames';

import {
  Button,
  ButtonSizeSM,
  ButtonSkinSecondary,
  ButtonVariants,
} from '@picsart/design-system/components/Button';
import { Text, TextElementTypes } from '@picsart/design-system/components/Text';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { IconChevronDownLarge } from '@picsart/design-system/foundation/icons/IconChevronDownLarge';
import { IconChevronUpLarge } from '@picsart/design-system/foundation/icons/IconChevronUpLarge';

import {
  ANALYTICS_NAMES,
  descriptionText,
  seeLessText,
  seeMoreText,
} from 'templates/components/SingleTemplate/constants';

import { useTranslator } from '@picsart/rc/services/localization';
import useDevice from 'hooks/useDeviceType';
import testIds from './testIds';
import { DescriptionProps } from './types';

import useStyles from './styles';

const Description = ({ title = descriptionText, content }: DescriptionProps) => {
  const [expandedText, setExpandedText] = useState(false);
  const classes = useStyles({ expandedText });

  const translate = useTranslator();

  const { isMobile } = useDevice();

  const handleExpandedTextClick = useCallback(() => {
    setExpandedText(!expandedText);
  }, [expandedText]);

  return (
    <div className={classes.root} data-testid={testIds.root}>
      <Text size={TypographyT6} weight={FontWeights.semibold} color={TextColors.base}>
        {translate(title)}
      </Text>
      <div className={classnames(classes.flexContainer, { [classes.t5]: !expandedText })}>
        <Text
          data-testid={testIds.descriptionSeeButton}
          elementType={TextElementTypes.Paragraph}
          size={TypographyT5}
          weight={FontWeights.medium}
          color={TextColors.base}
          className={classes.content}
        >
          {translate(content)}
        </Text>
        {isMobile && (
          <Button
            variant={ButtonVariants.Text}
            skin={ButtonSkinSecondary}
            size={ButtonSizeSM}
            startIcon={expandedText ? IconChevronUpLarge : IconChevronDownLarge}
            onClick={handleExpandedTextClick}
            className={classes.inlineButton}
            dataTestId={testIds.seeButton}
            data-pulse-name={ANALYTICS_NAMES.DESCRIPTION_SEE_BUTTON}
          >
            {translate(expandedText ? seeLessText : seeMoreText)}
          </Button>
        )}
      </div>
    </div>
  );
};

export default Description;
